import request from '@/utils/http-util'
import { baseUrl, yhfwUrl, yulin } from '/env'

export function getByIdApi(id, mode, viewCode) {
    return request({
        url: baseUrl + '/design/getById/' + id + '/' + mode + '/' + viewCode,
        method: 'get'
    })
}

export function authViewCodeApi(params) {
    return request({
        url: baseUrl + '/design/authViewCode',
        method: 'get',
        params
    })
}

export function uploadFileApi(fileName, data) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/file/upload?dir=design&fileName=' + fileName,
        method: 'post',
        data: data
    })
}
export function savePreviewApi(fileName, data) {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: baseUrl + '/file/savePreview?dir=design&fileName=' + fileName,
        method: 'post',
        data: data
    })
}

export function saveOrUpdateApi(data) {
    let saveUrl = '/design/saveOrUpdate'
    if (data.designType === 'screen-template') {
        saveUrl = '/design/saveTemplate'
    }
    return request({
        url: baseUrl + saveUrl,
        method: 'post',
        data
    })
}

export function pageListApi(params) {
    params.canRead = true
    return request({
        url: baseUrl + '/design/pageList',
        method: 'get',
        params
    })
}
export function deleteApi(id) {
    return request({
        url: baseUrl + '/design/delete?id=' + id,
        method: 'delete'
    })
}

export function mapApi(code) {
    return request({
        url: baseUrl + '/map/' + code,
        method: 'get'
    })
}
export function copyDesignApi(data) {
    return request({
        url: baseUrl + '/design/copyDesign',
        method: 'post',
        data
    })
}

export function listGroupAllApi(params) {
    return request({
        url: baseUrl + '/sysPermitsData/listDesignGroupAll',
        method: 'get',
        params
    })
}

export function listByTypeApi(params) {
    return request({
        url: baseUrl + '/design/listByType',
        method: 'get',
        params
    })
}


export function redirectUrl(params) {
    return request({
        url: yhfwUrl + '/platform/report/report-view-layui!getLayuiDataGrid.action',
        method: 'get',
        params
    })
}

// 美化接口
export class GetBeautify {
    static list(params) {
        return request({
            url: baseUrl + '/beautify/list',
            method: 'get',
            params
        })
    }
    static update(data) {
        return request({
            url: baseUrl + '/beautify/saveOrUpdate',
            method: 'post',
            data
        })
    }
    static get(params) {
        return request({
            url: baseUrl + '/beautify/get',
            method: 'get',
            params
        })
    }
}

// 获取支付跳转路径
export function getPayInfo(data) {
    let url = yulin + '/gdpay/gdyjf/pay'
    if (process.env.NODE_ENV === 'production') {
        url = 'https://www.xdwater365.com/gdpay/gdyjf/pay'
    }
    return request({
        url,
        method: 'post',
        data
    })
}

export function loginOut(url, data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}